import React, { useState,useEffect } from "react";
import event1_icon from "../images/event1.svg";
import intensity_icon from "../images/intensity.svg";
import goalTime_icon from "../images/goalTime.svg";
import distance1_icon from "../images/distance.svg";
import greaterWhite_icon from "../images/greaterWhite.svg";
import clockBlack_icon from "../images/clockBlack.svg";
import CoachLayout from "./common/CoachLayout";
import { CoachHeader } from "./common/CoachHeader";
import API_URL from '../api/API';
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

export const CoachMySplit= () => {


  const DEFAULT_INTENSITY=85;
  const PROGRAM_INTENSITY=100;


  const marks = {
    70: "70",
    75: "75",
    80: "80",
    85: "85",
    90: "90",
    95: "95",
    100: "100",
  };
 
  //lets build the state data here
  const [sport,setSport] = useState('Basketball'); // build this logic later when it comes.
  const [event_pace,setEventPace] = useState('');
  const [goal_time,setGoalTime] = useState('');
  const [intensity,setIntensity] = useState(DEFAULT_INTENSITY); //this value will come from the slider once integrated.
  const [training_distance,setTrainingDistance] = useState('');
  const [actual_time,setActualTime] = useState('');

  const [target_time,setTargetTime] = useState('_');
  const [performance,setPerformance] = useState('0');

  const eventDropdown = [100,200,400];
  const [showEventOpen,setShowEventOpen] = useState(false); 

  const distance100Dropdown = [30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150];
  const distance200Dropdown = [60, 80, 90, 120, 140, 150, 180, 200, 250];
  const distance400Dropdown = [100, 120, 150, 180, 200, 250, 300, 350, 400, 450];

  const [distanceDropdown,setDistanceDropdown] = useState([]);
  const [showDistanceOpen,setShowDistanceOpen] = useState(false);

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const roundToNearestPointFive = (num) => Math.round(num * 2) / 2;

    // Function to calculate target time (will add logic later)
const calculateTargetTime = () => {
  //console.log("Calculating target time...");

  //const target_time = ((((goal_time/(event_pace/100))/(intensity/100))/100*training_distance)).toFixed(2);
  const target_time = (Math.ceil(((((goal_time / (event_pace / 100)) / (intensity / 100)) / 100 * training_distance) * 10)) / 10).toFixed(1);

  //build logic for target time here //=(goalTime/(eventPace/100)/intensityLevel)/100*trainingDistance
  setTargetTime(target_time);     

  // Placeholder logic - replace this with actual calculation later
};

useEffect(() => {
  if (event_pace > 0 && goal_time > 0 && training_distance > 0) {
    calculateTargetTime();
  }
}, [intensity,event_pace, goal_time, training_distance]);



  const handleReset = async (e) => {
    e.preventDefault();

    setTargetTime('_');
    setPerformance('0');
    
    // Force state reset by setting to null first, then default value
    setIntensity(null);  
    setTimeout(() => setIntensity(DEFAULT_INTENSITY), 0);  

    setEventPace('');
    setGoalTime('');
    setTrainingDistance('');
    setActualTime('');
    setDistanceDropdown([]);
  }

  const handleSubmit = async (e) => {
        e.preventDefault();

        if(!sport || !event_pace || !goal_time || !intensity || !training_distance || !actual_time){
          setError("Please enter all of the inputs");
          return;
        }

       setError(null);
       setLoading(true);

       const performance = Math.round(((200/100)-(actual_time/((goal_time/((event_pace/100)/(PROGRAM_INTENSITY/100)))/100*training_distance)*100/100))*100); 
       //build logic for performance here //200-(actualTime/((goalTime/(eventPace/100)/100)/100*trainingDistance)*100)
       setLoading(false);
       setPerformance(performance);
      


      /*  try {
          const response = await fetch(API_URL.POST_TOOLS_MYSPLIT, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({sport,event_pace,goal_time,intensity,training_distance,actual_time}),
          });

          const json = await response.json();
          setLoading(false);

          if (response.ok) {
            setTargetTime(json.target_time);
            setPerformance(json.performance);
          } 
          else 
          {
            // Display error returned by the server
            setError(json.error || 'An error occurred. Please try again.');
          }
        } catch (err) {
          setLoading(false);
          setError('Failed to connect to the server. Please try again.');
        }
          */

};



  return (
    <CoachLayout>
      <div className="bg-black h-dvh overflow-y-auto relative pb-3">
        <CoachHeader />
        <div className="w-full max-w-2xl mx-auto shadowbg px-5 h-full">
          <div className="text-center relative roundedLineBreaK min-h-[150px] pt-4 mb-8 mt-5">
            <div>
              <p className="text-white text-[48px] font-normal leading-none mb-[5px] split-1">
               {target_time}
              </p>
              <span className="text-white text-[12px] font-normal !leading-none">
                TARGET TIME
              </span>
            </div>
            <div className="w-fit px-5 block mx-auto absolute -bottom-12 bg-black max-[389px]:-bottom-2 left-1/2 -translate-x-1/2 split-2">
              <p className="text-white text-[28px] font-medium leading-[95%]">
                {performance}%
              </p>
              <span className="text-white text-[10px] font-normal leading-[95%]">
                PERFORMANCE
              </span>
            </div>
          </div>
          {/* slider here */}
          <div className="my-7">
            <div className="flex flex-row items-center gap-[10px] pl-3">
              <img src={intensity_icon} alt="icon" className="object-contain" />
              <p className="text-white text-base font-normal tracking-[-0.408px]">
                {intensity}% Intensity
              </p>
            </div>
            <div style={{ padding: "10px", background: "#000", color: "#fff" }}>
              <Slider
                allowCross={false}
                min={70}
                max={100}
                value={intensity}
                marks={marks}
                trackStyle={{
                  backgroundColor: "red",
                  height: 6,
                }}
                handleStyle={{
                  borderColor: "#fff",
                  opacity: "1",
                  height: 14,
                  width: 14,
                  backgroundColor: "#fff",
                }}
                railStyle={{
                  backgroundColor: "gray",
                  height: 6,
                }}
                dotStyle={{
                  borderColor: "black",
                  backgroundColor: "black",
                  borderRadius: "0px",
                  height: "6px",
                  width: "2px",
                }}
                activeDotStyle={{
                  borderColor: "red",
                }}
                style={{
                  marginBottom: "20px",
                }}
                onChange={(value) => setIntensity(value)}
              />
            </div>
          </div>
          {/* __________________ */}
          <div className="flex flex-col gap-4">
            <div className="flex gap-[12px]">
              <div className="w-1/3 min-h-[80px] border border-white/10 rounded-[15px] py-4 px-3 flex flex-col gap-3">
                <img src={event1_icon} alt="icon" className="object-contain w-4" />
                <div
                  className="relative cursor-pointer"
                  onClick={() => setShowEventOpen(!showEventOpen)}
                >
                  <p className="text-white text-sm font-normal leading-none mb-3 capitalize">
                  Event {event_pace ? `/ ${event_pace}m` : ""}
                  </p>
                  <img
                    src={greaterWhite_icon}
                    alt="icon"
                    className={`object-contain w-3 ${
                      showEventOpen ? "rotate-180" : "rotate-0"
                    }`}
                  />
                  {showEventOpen && (
                    <ul className="absolute top-full h-fit -left-3 w-full min-w-full border border-white/20 focus:outline-none rounded-[10px] bg-black text-white mt-2 shadow-lg z-10">
                      {eventDropdown.map((option) => (
                        <li
                          key={option}
                          onClick={() => {
                            setEventPace(option);
                            setShowEventOpen(false);
                            if (option===100){
                              setDistanceDropdown(distance100Dropdown);
                            }
                            else if(option===200){
                              setDistanceDropdown(distance200Dropdown);
                            } 
                            else if(option===400){
                              setDistanceDropdown(distance400Dropdown);
                            }
                            else{
                              setDistanceDropdown([]);
                            }
                          }}
                          className="px-2 py-1 text-xs text-white hover:bg-gray-900 cursor-pointer rounded-[10px] overflow-hidden"
                        >
                          {option}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div className="w-1/3 min-h-[80px] border border-white/10 rounded-[15px] py-4 px-3 flex flex-col gap-3">
                <img src={goalTime_icon} alt="icon" className="object-contain w-4" />
                <input
                  type="text"
                  className="text-white text-base font-normal leading-none border-b border-white bg-transparent py-1 placeholder:text-white"
                  placeholder="Goal Time"
                  value={goal_time}
                  onChange={(element) => setGoalTime(element.target.value)}
                />
              </div>
              <div className="w-1/3 min-h-[80px] border border-white/10 rounded-[15px] py-4 px-3 flex flex-col gap-3">
                <img
                  src={distance1_icon}
                  alt="icon"
                  className="object-contain h-4 w-4"
                />
                <div
                  className="relative cursor-pointer"
                  onClick={() => setShowDistanceOpen(!showDistanceOpen)}
                >
                  <p className="text-white text-sm font-normal leading-none capitalize mb-3">
                    Distance {training_distance}
                  </p>
                  <img
                    src={greaterWhite_icon}
                    alt="icon"
                    className={`object-contain w-3 ${
                      showDistanceOpen ? "rotate-180" : "rotate-0"
                    }`}
                  />
                  {showDistanceOpen && (
                    <ul className="absolute top-full h-fit -left-3 w-full min-w-full border border-white/20 focus:outline-none rounded-[10px] bg-black text-white mt-2 shadow-lg z-10">
                      {distanceDropdown.map((option) => (
                        <li
                          key={option}
                          onClick={() => {
                            setTrainingDistance(option);
                            setShowDistanceOpen(false);
                          }}
                          className="px-2 py-1 text-xs text-white hover:bg-gray-900 cursor-pointer rounded-[10px] overflow-hidden"
                        >
                          {option}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div className="flex flex-row gap-[10px]">
              <div className="w-1/2 min-h-[80px] border border-white/10 rounded-[15px] py-4 px-3 flex flex-col gap-3 mr-1">
                <img
                  src={clockBlack_icon}
                  alt="icon"
                  className="object-contain w-4"
                />
                <input
                  type="text"
                  className="text-white text-base font-normal leading-none border-b border-white bg-transparent py-1 placeholder:text-white"
                  placeholder="Actual Time"
                  value={actual_time}
                  onChange={(element) => setActualTime(element.target.value)}
                />
              </div>
              <button onClick={handleReset} className="w-1/4 min-h-[80px] bg-[#171717] rounded-[15px] text-white/40 p-[16px_15px] flex flex-col justify-center items-center text-center uppercase text-[10px] font-normal">
                reset
              </button>
              <button onClick={handleSubmit} className="w-1/4 min-h-[80px] bg-white rounded-[15px] p-[16px_15px] text-center flex flex-col justify-center items-center">
                <span className="bg-black w-[30px] h-px block mb-[15px]"></span>
                <span className="bg-black w-[30px] h-px block"></span>
              </button>
            </div>
            
             {/* Display Loading Indicator */}
             {loading && (
                <p className="text-yellow-500 text-sm mt-2">
                  Processing request please wait...
                </p>
              )}

             {/* Display Error Message */}
             {error && (
                  <p className="text-red-500 text-sm mt-2">
                    {error}
                  </p>
              )}      

          </div>
        </div>
      </div>
    </CoachLayout>
  );
};
